import { createFileRoute } from "@tanstack/react-router";
import { SettingsEmails } from "@/screens/ParentSettingsSections";
// MA-861: the "Emails" section: the weekly recap toggle with its schedule and
// preview. /parent/settings/notifications redirects here.
export const Route = createFileRoute("/parent/settings/email")({ component: SettingsEmails });
